import React, { useState } from 'react';
import './metrology.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { Button } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { saveMetrology } from '../actions';
import { getResponseError } from '../../../utils/utils';
import UploadZone from '../../../components/fields/FileInput/UploadZone';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import MetrologyDTO from '../../../dto/MetrologyDTO';
import { getMetrologyData } from '../reducer';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';

export default function MetrologyForm(props) {
  const dispatch = useDispatch();
  const { loadData = () => {}, cancel = () => {} } = props;
  const { metrologyData = {} } = useSelector(getMetrologyData);
  const [file, setFile] = useState(null);
  const intl = useIntl();
  const { formatMessage } = intl;
  const { control, getValues } = useForm({
    mode: 'onBlur',
    defaultValues: metrologyData,
    resetOptions: {
      keepDirtyValues: true, // user-interacted input will be retained
      keepErrors: true, // input errors will be retained with value update
    },
  });

  const save = () => {
    let data = file;
    if (!file || !file.append) {
      data = new FormData();
    }
    const values = getValues();
    dispatch(saveMetrology({ ...values, certificate_image: file || '' })).then(() => loadData()).then(() => {
      cancel();
      successNotification(formatMessage({ id: 'metrology.save.title' }), formatMessage({ id: 'metrology.save.success' }));
    }).catch(response => {
      errorNotification(formatMessage({ id: 'metrology.save.title' }), getResponseError(response));
    });
  };

  const setFileClear = f => { window.clearFileFunction = f; };

  const onChangeFile = formData => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      setFile(reader.result);
    });
    reader.readAsDataURL(formData.get('file'));
  };

  const DTO = new MetrologyDTO();
  const attributes = DTO.getAttributesByName();
  return (
    <div className="metrology-info-block">
      <div className="metrology-image-wrapper">
        <div className="f4">{formatMessage({ id: 'metrology.certificate' })}</div>
        <div className="metrology-load-image-block mt-3">
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          {file ? <div><img className="mb-3" src={file} width="587px" /></div> : null}
          <UploadZone
            inputProps={{ onChange: onChangeFile }}
            setClear={setFileClear}
            zoneText={formatMessage({ id: 'metrology.file' })}
          />
        </div>
      </div>
      <div className="metrology-form">
        <div className="f4">{formatMessage({ id: 'metrology.verification.data' })}</div>
        <FieldDTO
          control={control}
          component={TextInputWithLabel}
          dtoObject={attributes.certificate_number}
          variant="material"
          className="mt-3"
        />
        <FieldDTO
          control={control}
          component={DateTimePicker}
          dtoObject={attributes.verification_date}
          variant="material"
          className="mt-3"
          withFormat="DD.MM.YYYY HH:mm"
          timeFormat="HH:mm"
          changeInitial
          withLabel
        />
        <FieldDTO
          control={control}
          component={DateTimePicker}
          dtoObject={attributes.verification_end_date}
          variant="material"
          className="mt-3"
          withFormat="DD.MM.YYYY HH:mm"
          timeFormat="HH:mm"
          changeInitial
          withLabel
        />
        <Button className="mt-3 save-button" onClick={save}>{formatMessage({ id: 'app.save' })}</Button>
        <Button variant="secondary" className="mt-3 mx-3 save-button" onClick={cancel}>{formatMessage({ id: 'app.cancel' })}</Button>
      </div>
    </div>
  );
}
